import React from "react"
import LandingLayout from "../layouts/landing"
import RoundImageWithSubtitle from "../components/RoundImageWithSubtitle"
import TwoThirdsGrid from "../components/layout/TwoThirdsGrid"
import Text from "../components/text/Text"
import HeadlineWithSub from "../components/text/HeadlineWithSub"
import { strichpunkt } from "../data/akkordeon"
import FourImageGrid from "../components/layout/FourImageGrid"
import * as PropTypes from "prop-types"

function WrapperDiv(props) {
  return null
}

WrapperDiv.propTypes = { children: PropTypes.node }
const Home = () =>
  <LandingLayout akkordeon={strichpunkt} image="/assets/images/IMG_6978.jpg">
    <TwoThirdsGrid textRight>
      <div>
        <HeadlineWithSub>
          <h1 style={{ hyphens: 'none' }}>Raum für Reflexion, Entwicklung und Gestaltung</h1>
        </HeadlineWithSub>
      </div>
      <div>
        <Text>
          <p>Ich begleite Menschen, die berufliche oder persönliche Fragen vertiefen, neue Perspektiven entwickeln oder Veränderungen bewusst gestalten möchten.</p>
          <p>Im Gespräch, im Gestalten oder in der Natur entstehen Räume, in denen Wahrnehmung, Reflexion und neue Zusammenhänge möglich werden.</p>

          <p> <strong>Themen</strong>
            <ul>
              <li>Orientierung und Neuausrichtung</li>
              <li>Berufliche Herausforderungen</li>
              <li>Beziehungen und Rollen</li>
              <li>Entscheidungen und Veränderungen</li>
              <li>Erschöpfung und Belastung</li>
              <li>Persönliche Entwicklung</li>
            </ul>
          </p>

          <p>
            <strong>Arbeitsort</strong> <br />
            In meiner Praxis in Appenzell, online oder bei einem gemeinsamen Spaziergang in der Natur.
          </p>

          <p>
            <strong>Termine nach Vereinbarung</strong> <br />
            Ich freue mich auf Ihre Kontaktaufnahme per <a href="tel:+41 79 844 04 07">Telefon</a> oder <a href="mailto:info@strich.sg">eMail</a>.
          </p>
        </Text>
      </div>
    </TwoThirdsGrid>
    <FourImageGrid>
      <RoundImageWithSubtitle text="Mal- & Gestaltungtherapie"
                              subtext="Sprache plus, Gestaltung, Handlungsraum, Betrachtung"
                              link="/mal-und-gestaltungstherapie" image="/assets/images/IMG_7007_smaller.jpeg" />
      <RoundImageWithSubtitle text="Coaching" subtext="Vertrauen, Handlungsraum, Klarheit, Entwicklung" link="/coaching"
                              image="/assets/images/IMG_7047.PNG" />
      <RoundImageWithSubtitle text="Natur als Denkraum" subtext="im Kontext Coaching & Therapie" link="/natur-als-denkraum"
                              image="/assets/images/IMG_6985.jpg" />
      <RoundImageWithSubtitle text="Weiterbildung" subtext="Natur, Wahrnehmung, Gestaltung, Prozess" link="/weiterbildung"
                              image="/assets/images/IMG_7210.jpeg" />
    </FourImageGrid>
  </LandingLayout>

export default Home